// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 771 ? "@atlaskit-internal_refractor-import" : chunkId) + "." + {"771":"10578680","787":"6d52e5b1"}[chunkId] + ".chunk.js";
};